export const CONCLUDED_STATUS = 'Concluído';
export const PENDING_STATUS = 'Pendente';
export const TO_DO_STATUS = 'A fazer';
